import React, { Suspense } from "react";
import styled from "styled-components";

import {
  AvisVerifies,
  LoadingBlock,
  Page,
  PageCMSLoader,
} from "../../components";
import BannersBlock from "../../components/Banner";
import { translate } from "../../services/translation.service";
import theme from "../../theme";
import "../../theme/cssLmdw/homepage.css";

import Target2SellCarouselNews from "./components/Target2SellCarouselNews";
import Target2SellCarouselSelection from "./components/Target2SellCarouselSelection";

const StyledAvisVerifies = styled(AvisVerifies)`
  margin-top: ${theme.margins.marginBase};
`;

const HomepageBlock = styled.div`
  &.homepage h2 {
    font-family: ${theme.fonts.regular};
    font-size: 22px;
  }
`;

export const Home = (): JSX.Element => {
  const pageType = "homepage";

  return (
    <Page
      backgroundColor={theme.colors.white}
      horizontalPadding={0}
      isHeaderSticky={true}
      tabTitle={translate("tabTitle.home")}
      pageType={pageType}
    >
      <BannersBlock pageType={pageType} template="homepage:events" />
      <HomepageBlock className="homepage">
        <Suspense fallback={<LoadingBlock />}>
          <PageCMSLoader id="homepage-greatest-choice" type="block_inpage" />
        </Suspense>
      </HomepageBlock>

      <BannersBlock pageType={pageType} template="homepage:selections" />

      <Target2SellCarouselNews title="Les nouveautés" />

      <HomepageBlock className="homepage">
        <Suspense fallback={<LoadingBlock />}>
          <PageCMSLoader id="homepage-gift-block" type="block_inpage" />
        </Suspense>
      </HomepageBlock>

      <Target2SellCarouselSelection title="Votre sélection personnalisée" />

      <HomepageBlock className="homepage">
        <Suspense fallback={<div />}>
          <PageCMSLoader id="homepage-history" type="block_inpage" />
        </Suspense>
      </HomepageBlock>

      <StyledAvisVerifies />
    </Page>
  );
};

export default Home;
